import React, { useState, useEffect } from "react"
import Image from "next/image"

const CustomImage = (props) => {
  const [error, setError] = useState(false);
  const { src, fallback, ...rest } = props;

  const isValidSrc = (src) => {
    if (!src || src === '#' || src === '') return false;
    return src.startsWith('/') || src.startsWith('http://') || src.startsWith('https://');
  };

  useEffect(() => {
    setError(false);
  }, [src]);

  if (!src || !isValidSrc(src) || error) {
    if (fallback) {
      return (
        <div 
          className={`${props.className} d-flex align-items-center justify-content-center bg-light text-muted`}
          style={{ 
            width: props.width, 
            height: props.height,
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          {fallback}
        </div>
      )
    }
    
    return (
        <img 
            src="/content/img/vl-circle.png" 
            alt="Placeholder"
            width={props.width}
            height={props.height}
            className={props.className}
            style={{ opacity: 0.5, filter: 'grayscale(1)' }}
        />
    )
  }

  if (process.env.production_type === "static") {
    return (
      <img
        src={src}
        alt={props.alt}
        width={props.width}
        height={props.height}
        className={props.className}
        onError={() => setError(true)}
      />
    )
  } else {
    return (
      <Image
        src={src}
        {...rest}
        onError={() => {
          console.warn('Image failed to load, using fallback:', src)
          setError(true);
        }}
      />
    );
  }
}
export default CustomImage
